import { produce } from "immer";
import { CLEANUPALLAGENTS, GETALLAGENTS } from "redux/actions/agentAction";

const initialState = {
    allAgents: null,
    count: null
};

export const agentReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case GETALLAGENTS:
                draft.allAgents = action.payload.data
                // draft.count = action.payload
                break;
            case CLEANUPALLAGENTS: 
                draft.allAgents = null    
            default:
                break;
        }
    });
};
